module.exports = __webpack_public_path__ + "assets/images/0c1b548b64d3616d031327a95a8d547d.png";